import { combineReducers } from 'redux';
import produce from 'immer';
import { ArtifactAction, ArtifactActionType } from '../../actions/artifactActions';
import { Artifact } from '../../types/resources';

type ByArtifactId = {
  [artifactId: string]: Artifact;
};

interface ByRunIdState {
  byRunId: Record<string, { byArtifactId: ByArtifactId }>;
}

export const initialState: ByRunIdState = {
  byRunId: {},
};

const byRunId = (state = initialState.byRunId, action: ArtifactAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ArtifactActionType.LIST_ARTIFACTS: {
        draft[action.runId] = { byArtifactId: {} };
        break;
      }
      case ArtifactActionType.LIST_ARTIFACTS_OK: {
        action.data.forEach((artifact) => {
          draft[action.runId].byArtifactId[artifact.id] = artifact;
        });

        break;
      }
      case ArtifactActionType.DELETE_ARTIFACTS_OK: {
        draft[action.runId] = { byArtifactId: {} };
        break;
      }
      case ArtifactActionType.DELETE_ARTIFACT_OK: {
        delete draft[action.runId].byArtifactId[action.artifactId];
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({
  byRunId,
});
